import { ShieldAlert, X } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { Button } from "@/components/ui/button";
import { useBreakGlass } from "@/hooks/use-break-glass";

export function BreakGlassBanner() {
  const { isActive, session, deactivate, remainingMs } = useBreakGlass();

  if (!isActive || !session) return null;

  const expiresLabel =
    remainingMs > 0
      ? `expires ${formatDistanceToNow(session.expiresAt, { addSuffix: true })}`
      : "expiring soon";

  return (
    <>
      <div className="fixed top-0 left-0 right-0 border-b border-amber-300 bg-amber-50 text-amber-950 z-[200] shadow-sm dark:bg-amber-500/10 dark:text-amber-200 dark:border-amber-500/30">
        <div className="px-6 py-3 flex flex-wrap items-center gap-3 justify-between max-w-[1600px] mx-auto">
          <div className="flex items-start gap-3 min-w-0 flex-1">
            <ShieldAlert className="h-5 w-5 shrink-0 text-amber-700 mt-0.5" />
            <div className="min-w-0">
              <p className="text-sm font-bold tracking-tight">
                Emergency access active - {expiresLabel}
              </p>
              <p className="text-xs text-amber-900/90 mt-0.5 truncate dark:text-amber-200">
                Justification: {session.reason}
              </p>
            </div>
          </div>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="border-amber-300 bg-white/80 hover:bg-white text-amber-900 shrink-0 dark:bg-card/80 dark:hover:bg-card dark:text-amber-200 dark:border-amber-500/30"
            onClick={deactivate}
          >
            <X className="h-3.5 w-3.5 mr-1.5" />
            End emergency access
          </Button>
        </div>
      </div>
      <div className="h-[68px] shrink-0" aria-hidden />
    </>
  );
}
